export { default as BannerHero } from './BannerHero';
